import { LoaderIcon } from '../../icons/LoaderIcon';
import { cn } from '../../utils/className';
import { LoaderProps } from './types';

export const Loader = ({ center, className: propsClassName }: LoaderProps) => {
  const loaderClassName = cn(
    'size-6',
    {
      'absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2': center,
    },
    propsClassName,
  );

  return (
    <div className={loaderClassName}>
      <LoaderIcon />
    </div>
  );
};
